import React from "react";
import { ArrowDownIcon } from "lucide-react";
type OfferLinkProps = {
  children: React.ReactNode;
  variant?: "primary" | "outline";
  className?: string;
};

// Bouton informatif : fait défiler la page jusqu'à la section offre.
export function OfferLink({
  children,
  variant = "primary",
  className = ""
}: OfferLinkProps) {
  const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-display font-extrabold tracking-wide transition-[background-color,color,transform,box-shadow] duration-150 ease-out focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-royal";
  const styles = variant === "primary" ? "bg-tangerine px-8 pb-3 pt-3.5 text-lg text-white shadow-[0_5px_0_#C4560A] hover:bg-tangerine-dark active:translate-y-[3px] active:shadow-[0_2px_0_#C4560A] md:text-xl" : "border-[3px] border-royal bg-white px-6 pb-2 pt-2.5 text-base text-royal hover:bg-royal hover:text-white active:scale-[0.97]";
  return <a href="#offre" className={`${base} ${styles} ${className}`} data-id="element-164" data-mp="mh70fh80jdc2">
      {children}
      {variant === "outline" && <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="reyrya4qwxfq" />}
    </a>;
}